import React from "react";

const services = [
  {
    id: 1,
    title: "Bronze Package",
    description: "Essential detailing to keep your vehicle fresh and clean.",
    alt: "Bronze Car Valeting Package - Basic exterior and interior cleaning service",
    image: "/assets/images/Bronze-Package-Image.jpg",
    price: "From: £20",
    features: [
      "Exterior washed using the 2-bucket method and high-quality shampoo",
      "Wheels cleaned, including iron fallout removal",
      "Snow foam applied before contact washing",
      "Door frames and returns wiped down",
      "Paintwork and wheels dried carefully",
      "Interior vacuumed and dusted",
      "Glass cleaned inside for a streak-free finish",
    ],
  },
  {
    id: 2,
    title: "Silver Package",
    description: "A refined valet service with premium interior care.",
    alt: "Silver Car Valeting Package - Exterior wash, wax, and interior deep clean",
    image: "/assets/images/Silver-Package-Image.jpg",
    price: "From: £60",
    features: [
      "Everything included in the Bronze Package, plus:",
      "Door frames and returns cleaned with extra attention",
      "Petrol cap cleaned with citrus pre-wash and brush",
      "TFR (Traffic Film Remover) applied before washing",
      "Bug and insect residue removal",
      "Wheel arches and tyres cleaned and dressed",
      "Detail cleaning using soft brushes",
      "Pet hair removal with specialist tools",
      "Plastic trims cleaned on all surfaces",
      "Carpets, mats, and foot pedals deep cleaned and refreshed",
    ],
  },
  {
    id: 3,
    title: "Gold Package",
    description: "Showroom-level detailing with paint protection.",
    alt: "Gold Car Valeting Package - Hand wash, ceramic coating, and engine bay cleaning",
    image: "/assets/images/Gold-Package-Image.jpg",
    price: "From: £110",
    features: [
      "Everything included in the Silver Package, plus:",
      "Detailed cleaning of badges and crevice areas",
      "Tar deposits removed where possible",
      "Exterior plastics cleaned and dressed",
      "Final gloss finish with detailer spray",
      "Engine bay cleaned and polished",
      "Wet vacuum of all seats (if fabric), floor mats and boot area",
      "Leather seats cleaned and conditioned (if applicable)",
      "Dashboard and vinyl surfaces cleaned and protected",
      "Floor mats jet washed",
      "Air freshener applied to all carpeted areas",
      "Roof lining cleaned thoroughly",
    ],
  },
  {
    id: 4,
    title: "Extras",
    description: "Enhance your valet with premium add-ons.",
    alt: "",
    image: "/assets/images/Extra-Package-Image.jpg",
    price: "Price: Varies",
    features: [
      "Comprehensive Clay Bar and Iron Fall Out Removal for Exterior and Alloys - from £90",
      "Single-Stage Machine Polish - from £210",
      "Two-Stage Paint Correction - from £430",
      "Advanced Paintwork Correction - from £850",
    ],
  },
];

const ServicesSection = () => {
  return (
    <section id="services" className="relative bg-[#0D172A] py-20">
      {/* Divider */}
      <div className="border-t-2 border-[#FFFFF] w-24 mx-auto my-12"></div>

      <h2 className="text-5xl font-bold text-center text-[#1C9BF8] mb-12 uppercase tracking-wide">
        Our Services
      </h2>

      {/* Services Grid */}
      <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {services.map((service) => (
          <div
            key={service.id}
            className="relative group overflow-hidden rounded-lg shadow-lg service-card transition-transform duration-300 hover:scale-105 bg-gray-900"
          >
            {/* Image with Overlay */}
            <div className="relative">
              <img
                src={service.image}
                alt={service.alt}
                className="w-full h-48 object-cover transition-opacity duration-300 group-hover:opacity-50"
              />
              <div className="absolute inset-0 bg-black bg-opacity-40"></div>
            </div>

            {/* Content (Left-Aligned) */}
            <div className="p-6 text-left"> {/* Changed from text-center to text-left */}
              <h3 className="text-2xl font-semibold text-[#1C9BF8] mb-2">{service.title}</h3>

              {/* Price (Ensure it always shows directly under the title) */}
              <p className="text-lg font-semibold text-[#1C9BF8] mb-2">{service.price}</p>

              <p className="text-gray-400 text-sm mb-4">{service.description}</p>

              {/* Features (Left Aligned) */}
              <ul className="text-gray-300 text-sm mb-4 space-y-2 list-disc pl-5 marker:text-[#1C9BF8]">
              {service.features.map((feature, index) => (
                <li key={index} className="leading-relaxed">
                  {feature}
                </li>
              ))}
            </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;
